
import React, { useState } from 'react';
import { getUserServiceLevel, login } from '../api/authApiCall';

import classnames from "classnames";
import { useNavigate } from 'react-router-dom'

import {
  UncontrolledAlert,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import AuthHeader from "components/Headers/AuthHeader.js";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import SubmitButton from './SubmitButton';
import { useTranslation } from '../i18n/context';


function Login() {
  const { t } = useTranslation();
  const [focusedEmail, setfocusedEmail] = React.useState(false);
  const [focusedPassword, setFocusedPassword] = React.useState(false);
  const navigate = useNavigate();
  const getServiceStatus = getUserServiceLevel();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    user_email: '',
    password: ''
  });

  const handleServiceSelection = (serviceLevel) => {
    localStorage.setItem('selectedServiceLevel', serviceLevel);
    // console.log(serviceLevel)
    navigate('/register');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Get the service level from localStorage
    const serviceId = getServiceStatus;
    // console.log(serviceId);

    try {
      // Check if service level is 1
      if (serviceId === '1') {
        setShowErrorAlert(true);
        setTimeout(() => {
          setShowErrorAlert(false);
        }, 3000);
        setIsSubmitting(false);
        return;
      }

      // Only proceed with login if service level is not 1
      const user = await login(formData);
      setShowSuccessAlert(true);
      setTimeout(() => {
        navigate('/admin/dashboard');
      }, 2000);

    } catch (error) {
      console.error('Login failed', error);
      setShowErrorAlert(true);
      setTimeout(() => {
        setShowErrorAlert(false);
      }, 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <IndexNavbar />
      <AuthHeader
        title={t('common.welcome')}
        lead={t('common.log')}
      />
      <Container className="mt--8 pb-6">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary border-0 mb-0">
              {showSuccessAlert && (
                <UncontrolledAlert color="success">
                  <span className="alert-text ml-1">
                    <strong>{t('common.success')}</strong> {t('common.successful')}
                  </span>
                </UncontrolledAlert>
              )}
              {showErrorAlert && (
                <UncontrolledAlert color="danger">
                  <span className="alert-text ml-1">
                    <strong>{t('common.error')} {t('common.wrong')}</strong>
                    {getServiceStatus === '1'
                      ? "Your service level does not allow login. Please upgrade your account."
                      : ""}
                  </span>
                </UncontrolledAlert>
              )}
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <small>{t('common.sign')}</small>
                </div>
                <Form role="form" onSubmit={handleSubmit}>
                  <FormGroup
                    className={classnames("mb-3", {
                      focused: focusedEmail,
                    })}
                  >
                    <InputGroup className="input-group-merge input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-email-83" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="email"
                        name="user_email"
                        value={formData.user_email}
                        onChange={handleChange}
                        placeholder="Email"
                        required
                        onFocus={() => setfocusedEmail(true)}
                        onBlur={() => setfocusedEmail(false)}
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup
                    className={classnames({
                      focused: focusedPassword,
                    })}
                  >
                    <InputGroup className="input-group-merge input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder={t('common.password')}
                        required
                        onFocus={() => setFocusedPassword(true)}
                        onBlur={() => setFocusedPassword(false)}
                      />
                      <InputGroupAddon addonType="append">
                        <InputGroupText
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: 'pointer' }}
                        >
                          <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                  <div className="text-center">
                    <SubmitButton
                      className="my-4"
                      color="info"
                      type="submit"
                      isLoading={isSubmitting}
                    >
                      {t('common.signin')}
                    </SubmitButton>
                  </div>
                </Form>
              </CardBody>
            </Card>
            <Row className="mt-3">
              <Col xs="6">
                <a className="text-light" href="/password-reset-request">
                  <small style={{ fontWeight: 'bolder', color: 'black' }}>
                    {t('common.forgot')}
                  </small>
                </a>
              </Col>
              <Col className="text-right" xs="6">
                <a className="text-light" onClick={() => handleServiceSelection(2)}>
                  <small style={{ fontWeight: 'bolder', color: 'black', cursor: 'pointer' }}>
                    {t('common.create')}
                  </small>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Login;
